import { render, staticRenderFns } from "./StudentFreeSituationEdit.vue?vue&type=template&id=6fb31fba&scoped=true"
import script from "./StudentFreeSituationEdit.vue?vue&type=script&lang=js"
export * from "./StudentFreeSituationEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentFreeSituationEdit.vue?vue&type=style&index=0&id=6fb31fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb31fba",
  null
  
)

export default component.exports